import { CreateNotificationRuleBasicInformationForm } from '@/features/notification-rules/components/create-notification-rule/steps-form/create-notification-rule-basic-information-form.tsx';
import { CreateNotificationRuleConditionsForm } from '@/features/notification-rules/components/create-notification-rule/steps-form/create-notification-rule-conditions-form.tsx';
import { NotificationRuleMessageTemplateForm } from '@/features/notification-rules/components/shared/notification-rule-message-template-form.tsx';
import { CreateNotificationRuleOtherOptionsForm } from '@/features/notification-rules/components/create-notification-rule/steps-form/create-notification-rule-other-options-form.tsx';
import {
  basicInformationFormSchema,
  conditionsFormSchema,
  messageTemplateFormSchema,
  otherOptionsFormSchema,
} from '@/features/notification-rules/schemas/create-notification-rule.schema.ts';

const ALL_STEPS = [
  {
    id: 'basic-info',
    title: 'Basic Information',
    Element: CreateNotificationRuleBasicInformationForm,
    schema: basicInformationFormSchema,
  },
  {
    id: 'conditions',
    title: 'Conditions',
    Element: CreateNotificationRuleConditionsForm,
    schema: conditionsFormSchema,
  },
  {
    id: 'message-template',
    title: 'Notification Description',
    Element: NotificationRuleMessageTemplateForm,
    schema: messageTemplateFormSchema,
  },
  {
    id: 'other-options',
    title: 'Other options',
    Element: CreateNotificationRuleOtherOptionsForm,
    schema: otherOptionsFormSchema,
  },
] as const;

export type CreateNotificationRuleStep = (typeof ALL_STEPS)[number];

export function getCreateNotificationRuleSteps() {
  return ALL_STEPS.map((s, i) => ({ ...s, step: i + 1 }));
}
